import MUIDataTable from 'mui-datatables';
import React from 'react'
import { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import Toggle from 'react-toggle';
import { getDoorList , updateDoor, DeleteCarDoor } from '../../../actions';

const CarModel = () => {

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getDoorList())
	},[])

	const doorList = useSelector(state => state.home.doorList)?.response

	const handleStatusChange = (Id,active)=>{
		var data ={
			doorId: Id,
			active : !active
		}
		dispatch(updateDoor(data))
	}

	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarDoor(ID))
		}
	}

	console.log("doorList", doorList);

  const carModelList = []
  let columns = [];

		columns = [
			{
				name: 'door',
				label: 'Doors',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'doorAr',
				label: 'Doors Ar',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'priority',
				label: 'Priority',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'active',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (active, tableMeta) => {
						var Id = tableMeta.rowData[2];
						// console.log(tableMeta.rowData[6]);
						return (
							<Toggle
								id={'status_' + Id}
								defaultChecked={active}
								value={active}
								onChange={()=>handleStatusChange(Id, active)}
							/>
						);
					},
				},
			},
			{
				name: 'doorId',
				label: 'Action',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (doorId) => {
						return (
							<div>
								<Link to={`/CarDetail/Doors/Update/${doorId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
								<span className='delBTN' onClick={()=>HandleDelete(doorId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
							</div>
						);
					},
				},
			},

		];
    
		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					// noMatch: this.state.isSaving
					// 	? 'Loading data..!'
					// 	: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/CarDetail/Doors/Add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Doors
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{carModelList !== undefined ? (
												<MUIDataTable
													title={`Doors`}
													className='table-responsive'
													data={doorList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default CarModel